import { useTranslation } from "react-i18next";
import { BadgeIcon } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const EmployeeBiometricsSection = ({ formData, updateField }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <h3 className="font-medium flex items-center space-x-2">
        <BadgeIcon className="h-4 w-4" />
        <span>{t("employeesPage.sections.biometrics")}</span>
      </h3>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="fingerprint_id">{t("employeesPage.labels.fingerprintId")}</Label>
          <Input id="fingerprint_id" placeholder={t("employeesPage.placeholders.fingerprintId")} value={formData.fingerprint_id} onChange={(e) => updateField("fingerprint_id", e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="face_id">{t("employeesPage.labels.faceId")}</Label>
          <Input id="face_id" placeholder={t("employeesPage.placeholders.faceId")} value={formData.face_id} onChange={(e) => updateField("face_id", e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="card_id">{t("employeesPage.labels.cardId")}</Label>
          <Input id="card_id" placeholder={t("employeesPage.placeholders.cardId")} value={formData.card_id} onChange={(e) => updateField("card_id", e.target.value)} />
        </div>
      </div>
    </div>
  );
};

export default EmployeeBiometricsSection;
